import React from 'react';
import { Badge } from '../ui/badge';
import { AlertCircle, AlertTriangle, Info, CheckCircle2 } from 'lucide-react';
import { cn } from '../../lib/utils';

/**
 * CategoryBadge Component
 * 
 * Displays ASQ domain badges with color coding and severity indicators.
 */
const CategoryBadge = ({ domain, severity = 'none', showSeverity = true, className }) => {
  // Domain color mapping
  const domainColors = {
    communications: 'bg-blue-100 text-blue-800 border-blue-300',
    gross_motor: 'bg-green-100 text-green-800 border-green-300',
    fine_motor: 'bg-purple-100 text-purple-800 border-purple-300',
    cognitive: 'bg-orange-100 text-orange-800 border-orange-300',
    personal_social: 'bg-pink-100 text-pink-800 border-pink-300',
    general: 'bg-gray-100 text-gray-800 border-gray-300'
  };

  // Domain labels
  const domainLabels = {
    communications: 'Communications',
    gross_motor: 'Gross Motor',
    fine_motor: 'Fine Motor',
    cognitive: 'Cognitive',
    personal_social: 'Personal/Social',
    general: 'General'
  };

  // Severity icon mapping
  const severityIcons = {
    high: <AlertCircle className="h-3 w-3" />,
    medium: <AlertTriangle className="h-3 w-3" />,
    low: <Info className="h-3 w-3" />,
    none: <CheckCircle2 className="h-3 w-3" />
  };

  // Severity color mapping
  const severityColors = {
    high: 'text-red-600',
    medium: 'text-yellow-600',
    low: 'text-blue-600',
    none: 'text-gray-600'
  };

  const domainColor = domainColors[domain] || domainColors.general;
  const domainLabel = domainLabels[domain] || domain;

  return (
    <div className={cn('flex items-center gap-1', className)}>
      <Badge className={cn('text-xs font-medium', domainColor)}>
        {domainLabel}
      </Badge>
      {showSeverity && severity !== 'none' && (
        <span className={cn('flex items-center', severityColors[severity])}>
          {severityIcons[severity]}
        </span>
      )}
    </div>
  );
};

export default CategoryBadge;

